<!-- @format -->
<script lang="ts">
  import { valueGetters } from "~/components/field-utils";
  import VisioApp from "~/components/map/vg/VisioApp.svelte";
  import { type VisioMapAppConfig } from "~/components/map/vg/visiomap";
  import { getStoresContext, type StoresKey } from "~/stores";

  export let request_store_key: StoresKey;
  export let config: VisioMapAppConfig;
  export let fragment: Fragment;
  const { locale } = getStoresContext(request_store_key);
  const stores_context = getStoresContext(request_store_key);
  const { getText } = valueGetters(stores_context);

  $: title = $locale ? getText("title", fragment) : "";
</script>

<div class="container-fluid container-fluid-max-xl pt-5">
  {#if title}
    {@html title}
  {/if}
  <div class="map-container">
    <div class="map">
      <VisioApp {request_store_key} {config} />
    </div>
  </div>
</div>

<style lang="scss">
  .map-container {
    position: relative;
  }
  .map :global(.vc) {
    background-color: #fff;
    border-radius: 10px;
  }
  .map :global(.overlay) {
    border-radius: 10px;
  }
  .map {
    width: 100%;
    height: 400px;
    border: 2px solid #e40046;
    border-radius: 10px;
  }
</style>
